<template>
    <div class="mb-18">
        <!-- * Iconed Action Sheet -->
        <div class="alert body-alertDriver" role="alert">

            <h4 class="alert-title">راننده گرامی</h4>
            <p class="m-2 mb-0 mt-0" :class="{ 'alert-text': owner?.isAccepted == 1 }">
                {{ owner?.isAccepted == 1 ? 'صاحب بار / باربری احراز هویت شده است.' : 'از پرداخت هرگونه وجه به عنوان کمیسیون و ... به صاحب بار خودداری نمایید' }}
            </p>
            <p class="m-0" style="text-align: left">
                <a data-bs-toggle="offcanvas" @click="knowMore" data-bs-target="#actionReport" class="text-danger">
                    گزارش تخلف
                </a>
                <a data-bs-toggle="offcanvas" @click="knowMore" data-bs-target="#actionMore"
                    class="btn text-TEAL">بیشتر
                    بدانید!
                </a>
            </p>
            <!-- Form Action Sheet -->
            <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionReport">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title">گزارش تخلف</h5>
                </div>
                <div class="offcanvas-body">
                    <div class="action-sheet-content">
                        <form @submit.prevent="handleReport">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="form-label" for="name3">توضیحات</label>
                                    <textarea id="description" v-model="report.description" rows="3"
                                        placeholder="گزارش خود را بنویسید" class="form-control"></textarea>
                                </div>
                                <!-- <div class="input-info">نام و نام خانوادگی را وارد کنید</div> -->
                            </div>

                            <div class="form-group basic">
                                <button class="btn background-ORANGE text-light btn-block btn-block"
                                    data-bs-dismiss="offcanvas" type="submit">
                                    ارسال
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- * Form Action Sheet -->
            <!-- Content Action Sheet -->
            <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionMore">
                <div class="offcanvas-header">
                    <h5 class="offcanvas-title">هشدار</h5>
                    <button type="button" :id="'closeAlert_' + loadId" data-bs-dismiss="modal" style="display: none">
                        <ion-icon name="close-circle-outline" role="img" class="md hydrated"
                            aria-label="flash outline"></ion-icon>
                    </button>
                </div>
                <div class="offcanvas-body">
                    <div class="action-sheet-content">
                        <h4>در این موارد به شدت احتیاط کنید:</h4>
                        <ul class="dotted">
                            <li>ایران ترابر هیچ‌گونه مسئولیتی در قبال پرداخت‌های احتمالی شما به عنوان کمیسیون، رزرو بار،
                                شیرینی و ... به صاحبین بار نخواهد داشت.</li>
                            <li>آگهی کننده بار درخواست کمیسیون و.. دارد. (توجه نمایید که ایران ترابر اکیداٌ توصیه می‌کند
                                از پرداخت وجه بابت کمیسیون و... به آگهی کننده بار خودداری نمایید.)</li>
                            <li>آگهی کننده بار اطلاعات دقیقی از مکان بارگیری ارئه نمی‌دهد.</li>
                            <li>آگهی کننده بار درخواست حمل بار بدون صدور بارنامه را دارد.</li>
                            <li>قیمت کرایه بالا، غیرعادی و وسوسه کننده است.</li>
                        </ul>
                        <h4 class="text-center px-3 text-orange">توجه: در صورت مشاهده هرگونه آگهی مشکوک با تیم پشتیبانی
                            با ما تماس بگیرید.</h4>
                        <a href="#" class="btn btn-list text-danger d-none" :id="'knowMore_' + loadId"
                            data-bs-dismiss="offcanvas">
                            <span>بستن</span>
                        </a>
                        <a :href="tel" class="btn background-TEAL btn-block text-light btn-block mb-1">
                            <ion-icon name="call-outline" role="img" class="md hydrated"
                                aria-label="logo dropbox"></ion-icon>
                            تماس با پشتیبانی
                        </a>
                        <a href="/terms-and-conditions" class="btn background-TEAL btn-block text-light btn-block">
                            <ion-icon name="help-buoy-outline" role="img" class="md hydrated" aria-label="logo dropbox">
                            </ion-icon>
                            قوانین و مقررات
                        </a>
                    </div>
                </div>
            </div>
            <!-- * Content Action Sheet -->
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
    name: 'alertDriver',
    props: ['loadId', 'owner'],
    data() {
        return {
            tel: 'tel:' + window.localStorage.getItem("tel"),
            report: {
                type: 'driver',
                load_id: this.loadId,
                owner_id: null,
            },
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            }
        };
    },
    methods: {
        knowMore() {
            localStorage.setItem("knowMore", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?knowMore=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
        handleReport() {
            axios.post("https://core.iran-tarabar.ir/api/driver/report", this.report, this.axiosConfig)
                .then((response) => {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "تخلف شما با موفقیت ثبت شد",
                        showConfirmButton: false,
                        timer: 2000
                    });
                });
        },

    }
}
</script>
<style scoped>
.alert-text{
    color: #1d8d80;
    font-weight: 500;
}
ul.dotted {
    list-style-type: square;
}

.mb-18 {
    margin-bottom: 18px;
}

.btn-more {
    color: #ff5e00;
}

.body-alertDriver {
    border: 1px solid #ff5e005e;
    margin-bottom: 2rem;
}

.text-orange {
    color: #ff5e00;
}
</style>